import { render } from "./ForumSelectLang.vue?vue&type=template&id=8f43c754&scoped=true"
import script from "./ForumSelectLang.vue?vue&type=script&scoped=true&lang=js"
export * from "./ForumSelectLang.vue?vue&type=script&scoped=true&lang=js"

import "./ForumSelectLang.vue?vue&type=style&index=0&id=8f43c754&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f43c754"]])

export default __exports__